// Helper function to retrieve the `classy-session-id` from local storage
export const getClassySessionId = (): string | undefined => {
  const classyDataStr = localStorage.getItem('classy-session-id') || undefined

  if (!classyDataStr) {
    const heapData = JSON.parse(
      localStorage.getItem(`_hp5_event_props.${process.env.NEXT_PUBLIC_HEAP_APP_ID}`) || '{}',
    )

    return heapData?.value?.['classy-session-id']
  }

  return classyDataStr
}
